/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AccountDeletionReason {
    FOUND_RELATIONSHIP_PULSE = 'FOUND_RELATIONSHIP_PULSE',
    FOUND_RELATIONSHIP_OTHER = 'FOUND_RELATIONSHIP_OTHER',
    TAKING_BREAK = 'TAKING_BREAK',
    NOT_ENOUGH_MESSAGES = 'NOT_ENOUGH_MESSAGES',
    TOO_EXPENSIVE = 'TOO_EXPENSIVE',
    OTHER = 'OTHER',
}
